let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("acV6I")).then(() => parcelRequire('gBg3w'));